module.exports = __webpack_public_path__ + "img/InvoiceIconNEW3.16afad0a.png";